import {
  type AxiosRequestConfig,
  type DefaultQueryError,
  publicHttpClient,
} from '@ahm/api-wrappers-core';
import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import { apiRoutes } from './api-routes';

interface AhamoveLoginRequestBody {
  access_token: string;
}

export interface AhamoveLoginResponse {
  customer_id: string;
  access_token: string;
  ahamove_id: string;
}

export const ahamoveLoginFn = async (
  body: AhamoveLoginRequestBody,
  config: AxiosRequestConfig = {}
): Promise<AhamoveLoginResponse> => {
  const response = await publicHttpClient.post<AhamoveLoginResponse>(
    apiRoutes.ahafood.store.ahamove_login,
    body,
    {
      ...config,
      //   headers: {
      //     ...config.headers,
      //     'Content-Type': 'application/json',
      //   },
    }
  );

  return response?.data;
};

export const useAhamoveLogin = (
  opts?: UseMutationOptions<
    AhamoveLoginResponse,
    DefaultQueryError,
    AhamoveLoginRequestBody
  >
) => {
  return useMutation<
    AhamoveLoginResponse,
    DefaultQueryError,
    AhamoveLoginRequestBody
  >({
    mutationFn: ahamoveLoginFn,
    ...opts,
  });
};
